import React from 'react';
import { GoogleMap, Marker, useLoadScript, InfoWindow, Polyline } from "@react-google-maps/api";
import { useMemo } from "react";
import { useState, useEffect, useRef } from 'react';
import { Box, MenuItem, Select, useTheme, TextField, Button } from "@mui/material";
import CustomTable from './CustomTable.jsx';
import SearchIcon from '@mui/icons-material/Search';
import { tokens } from "../theme.js";
import survey_icon from "../icon/survey_marker.png";
import agent_icon from "../icon/agent_marker.png";
import { API_BASE } from "../api";

const mapContainerStyle = {
  width: '50%',
  height: '650px',
  borderRadius: '18px',
  marginLeft: "20px",
  marginTop: "25px",
};


export default function GeographyChart() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [markers, setMarkers] = useState([]);
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [currentStateName, setCurrentStateName] = useState('Select State');
  const [currentStateId, setCurrentStateId] = useState(null);
  const [currentCampaignName, setCurrentCampaignName] = useState('Select Campaign');
  const [camp, setCamp] = useState([]);
  const [currentCampId, setCurrentCampId] = useState(null);
  const [currentDistrictName, setCurrentDistrictName] = useState('Select District');
  const [currentDistId, setCurrentDistId] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [selectedMarker, setSelectedMarker] = useState(null);
  const [MarkRoute, setMarkRoute] = useState([]);
  const [recentSurveys, setRecentSurveys] = useState([]);
  const [mapCenter, setMapCenter] = useState({ lat: 26.8467, lng: 80.9462 });
  const mapRef = useRef(null);
  const center = useMemo(() => mapCenter, [mapCenter]);
  const { isLoaded } = useLoadScript({googleMapsApiKey: 'AIzaSyAVwxZr-a1ssarWGrgoi2t7xX7QgcFega8'});
  const [showMarker, setShowMarker] = useState(markers)
  const [plotSurveyOnMap, setPlotSurveyOnMap] = useState([]);

  useEffect(() => {
    fetch(`${API_BASE}/states`).then(response => {
      return response.json()
    }).then(data => {
      setStates(data.result);
    })
  }, [])

  function mobileSearch() {
    fetch(`${API_BASE}/userLocation?phone=${searchValue} `).then(response => {
      return response.json();
    })
      .then((data) => {
        let usermark = []
        data?.result?.map(user => {
          if (user !== null && user?.latitude !== null && user?.longitude !== null) {
            usermark.push({
              id: 1,
              geocode: { lat: user.latitude, lng: user.longitude },
              popUp: user.name,
              last5Cords: user?.last5Cords?.map(coord => ({ lat: coord.latitude, lng: coord.longitude }))
            })
          }
        })
        setMarkers(usermark);
      })
  }

  useEffect(() => {
    fetch(`${API_BASE}/stateUserLocation?stateId=${currentStateId}&districtId=${currentDistId}&campId=${currentCampId}`).then(response => {
      return response.json();
    })
      .then((data) => {
        let usermark = []
        let i = 1;
        data?.result?.map(user => {
          if (user !== null && user?.latitude !== null && user?.longitude !== null) {
            usermark.push({
              id: i++,
              geocode: { lat: user.latitude, lng: user.longitude },
              popUp: user.name + ',' + user.phone,
              last5Cords: user?.last5cords?.map(coord => ({ lat: coord.latitude, lng: coord.longitude })),
              recentSurveys: user?.last5Survey

            })
          }
        })
        setMarkers(usermark);
      })
  }, [currentStateId, currentDistId, currentCampId])

  const fetchDistrict = () => {
    fetch(`${API_BASE}/districts?state_id=${currentStateId}`)
      .then(response => response.json())
      .then(data => {
        setDistricts(data?.result.districtList);
      });
  };

  const fetchCampaign = () => {
    fetch(`${API_BASE}/campaigns?state_id=${currentStateId}`)
      .then(response => response.json())
      .then(data => {
        setCamp(data?.result);
      });
  }

  useEffect(() => {
    fetchDistrict();
    fetchCampaign();
  }, [currentStateId]);

  const handleState = (event) => {
    const selectedName = states.find((state) => state.id === event.target.value)?.name;
    setCurrentStateName(selectedName);
    setCurrentStateId(event.target.value);
    setCurrentDistrictName('Select District');
    setCurrentCampId('');
    setCurrentCampaignName('Select Campaign');
    setCurrentDistId('')
    setMarkers([]);
    setMarkRoute([]);
    setSelectedMarker(null);
  };
  const handleCamp = (event) => {
    const selectedName = camp.find((cmp) => cmp.id === event.target.value)?.title;
    setCurrentCampaignName(selectedName);
    setCurrentCampId(event.target.value);
    setMarkers([]);
    setMarkRoute([]);
    setSelectedMarker(null);
  };

  const handleDistrict = (event) => {
    const selectedName = districts.find((district) => district.id === event.target.value)?.name;
    setCurrentDistrictName(selectedName);
    setCurrentDistId(event.target.value);
    setMarkers([]);
    setMarkRoute([]);
    setSelectedMarker(null);
  };

  const handleInputChange = (event) => {
    setSearchValue(event.target.value);
  };

  const handleSearch = () => {
    mobileSearch();
  }

  useEffect(() => {
    setShowMarker(markers)
  }, [markers])

  const handleMarkerClick = (pin) => {
    setSelectedMarker(pin);
    setShowMarker([pin]);
    setMarkRoute(pin?.last5Cords);
    setRecentSurveys(pin?.recentSurveys);

  };
  return (
    <div style={{ marginLeft: "3%", marginTop: "2%" }}>
      <Box display="flex" justifyContent="flex-start" width="100%" p={2}>
        {/* state */}
        <Box
          display="flex"
          backgroundColor={colors.primary[400]}
          borderRadius="3px"
          width="250px"
          marginLeft="8px"
          zIndex="999"
        >

          <Select
            sx={{
              ml: 2,
              flex: 1,
              minWidth: '100px',
              marginLeft: '0px'
            }}
            onChange={handleState}
            value={currentStateName}
          >
            <MenuItem value={currentStateName} disabled>
              {currentStateName}
            </MenuItem>
            {states && states.map((state) => (
              <MenuItem key={state.id} value={state.id}>
                {state.name}
              </MenuItem>
            ))}
          </Select>
        </Box>

        {/* camp id */}
        <Box
          display="flex"
          backgroundColor={colors.primary[400]}
          borderRadius="3px"
          width="250px"
          marginRight="20px"
          marginLeft="30px"
        >
          <Select
            sx={{
              ml: 2,
              flex: 1,
              minWidth: '100px',
              marginLeft: '0px'
            }}
            onChange={handleCamp}
            value={currentCampaignName}
          >
            <MenuItem value={currentCampaignName} disabled>
              {currentCampaignName}
            </MenuItem>
            {camp && camp.map((cmp) => (
              <MenuItem key={cmp.id} value={cmp.id}>
                {cmp.title}
              </MenuItem>
            ))}
          </Select>
        </Box>
        {
          districts ? (
            <Box
              display="flex"
              backgroundColor={colors.primary[400]}
              borderRadius="3px"
              width="250px"
              marginLeft="10px"
              zIndex="999"
            >
              <Select
                sx={{
                  ml: 2,
                  flex: 1,
                  minWidth: '100px',
                  marginLeft: '0px'
                }}
                onChange={handleDistrict}
                value={currentDistrictName}

              >
                <MenuItem value={currentDistrictName} disabled>
                  {currentDistrictName}
                </MenuItem>
                {districts && districts.map((district) => (
                  <MenuItem key={district.id} value={district.id}>
                    {district.name}
                  </MenuItem>
                ))}
              </Select>
            </Box>
          ) : null
        }
        {/* <Box
          display="flex"
          backgroundColor={colors.primary[400]}
          borderRadius="8px"
          width="275px"
          marginLeft="21.5%"
          zIndex="999"
        >
          <TextField
            value={searchValue}
            onChange={handleInputChange}
            placeholder='Mobile Search'
            paddingleft="30px"

          />
          <Button type="button" className="re_custom_btn" onClick={handleSearch}><SearchIcon/></Button>
        </Box> */}

      </Box>
      <div style={{ display: "flex" }}>
        {isLoaded && showMarker ? (
          <GoogleMap
            mapContainerStyle={mapContainerStyle}
            zoom={6}
            center={center}
          >
          
            {showMarker.map((pin) => {
              return <Marker key={pin.id} position={pin.geocode} icon={{
                url: agent_icon,
                scaledSize: new window.google.maps.Size(45, 45),
              }} onClick={() => {handleMarkerClick(pin)}} />
            })}

            {plotSurveyOnMap.map((pin)=>{
              return <Marker key={pin.id} position={pin.geocode} icon={{
                url: survey_icon,
                scaledSize: new window.google.maps.Size(50, 50),
              }}
              />
            })}
            {selectedMarker && (
              <InfoWindow
                position={selectedMarker.geocode}
                onCloseClick={
                  () => {
                    setSelectedMarker(null);
                    setShowMarker(markers);
                    setMarkRoute([]);
                    setRecentSurveys([])
                    setPlotSurveyOnMap([]);
                  }
                }
              >
                <div style={{ color: 'black' }}>{selectedMarker.popUp}</div>
              </InfoWindow>
            )}
            {MarkRoute && <Polyline
          path={MarkRoute}
          options={{
            strokeColor: "#ff655a",
            strokeOpacity: 1.0,
            strokeWeight: 3,
          }}
        />}
          </GoogleMap>
        ) : null}
        <CustomTable recentSurveys={recentSurveys} setPlotSurveyOnMap={setPlotSurveyOnMap} plotSurveyOnMap={plotSurveyOnMap} />
      </div>
    </div>
  );
}
